import type { FC, HTMLAttributes } from 'react'
import styles from './form-group.module.css'

export interface FormGroupProps extends HTMLAttributes<HTMLDivElement> {
  row?: boolean
}

export const FormGroup: FC<FormGroupProps> = ({ row, className, children, ...rest }) => {
  const classes = [styles.formGroup, row ? styles.row : undefined, className]
    .filter(Boolean)
    .join(' ')

  return (
    <div className={classes} {...rest}>
      {children}
    </div>
  )
}
